import { createSlice } from "@reduxjs/toolkit";

//STATE
const state = {
  rows: [],
  forRentSetsDetails: {},
  isLoading: false,
  showDialog: false,
};

//STORE SLICE
export const forRentSetsDetailsSlice = createSlice({
  name: "forRentSetsDetailsSlice",
  initialState: state,
  //REDUCER
  reducers: {
    showForRentSetsDetailsDialog(state, action) {
      return {
        ...state,
        showDialog: true,
        forRentSetsDetails: action.payload,
      };
    },
    closeForRentSetsDetailsDialog(state) {
      return {
        ...state,
        showDialog: false,
      };
    },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    },    
  },
});

//ACTIONS
export const {
  showForRentSetsDetailsDialog,
  closeForRentSetsDetailsDialog,
  showLoading,
  hideLoading
} = forRentSetsDetailsSlice.actions;

export default forRentSetsDetailsSlice.reducer;
